exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-toolbar__menu[data-v-de292316]{display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end}.main-toolbar__menu .main-toolbar-back__menu-item[data-v-de292316]{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-de292316","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/toolbar/toolbar.vue
// module id = 214
// module chunks = 0